// routes/DemoRequestRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import RevenueTeardown from '../components/Frontend/RevenueTeardown/RevenueTeardown';
import RevenueNoData from '../components/Frontend/RevenueTeardown/FallBack/RevenueNoData';


export const revenueTeardownRoutes = (
  <Route path="/revenue_teardown" element={<MainLayout />}>
    <Route index element={<RevenueNoData />} />
    <Route path=":clientName/:competitorName" element={<RevenueTeardown />} />
  </Route>
);
